export const lenderFieldConfiguration = [
  {
    name: "name",
    label: "Lender Name",
    type: "text",
    validation: { required: "Name is required" },
  },
  {
    name: "email",
    label: "Email",
    type: "text",
    validation: { required: "Email is required" },
  },
  {
    name: "phoneNumber",
    label: "Phone Number",
    type: "text",
    validation: { required: "Phone number is required" },
  },
];

export const lenderInitialValues = {
  name: "",
  email: "",
  phoneNumber: "",
};
